import { TOKEN_TYPE } from "../TokenType.js";
import Token from "../Token.js";

export default class NumberToken extends Token {
    constructor( value ) {
        super( TOKEN_TYPE.NUMBER, value );
    }

    toString() {
        return this.value;
    }
}
